import styled from 'styled-components';

import { px } from '../../../../contrib/ui';

export const TeamsCreatorStyled = styled.div`
  width: 100%;

  .input-form-control {
    width: 100%;
    margin-bottom: ${px(10)};
  }

  .team-cards-container {
    padding: 0;
    margin-bottom: ${px(40)};

    .player-card {
      margin-bottom: ${px(15)};
    }
  }
`;
